const RegisteredComponents: any = {}


export const RegisterComponent = (type: string, comp: any) => {
    RegisteredComponents[type] = comp;
}

export const getRegisteredComponent = (type: string): any => {
    return RegisteredComponents[type]
}

import { Form } from '../components/form';
import { Panel } from '../components/panel';
import { Card } from '../components/card';
import { Tabs } from '../components/tabs';
import { Tab } from '../components/tab';
import { Expansionspanel } from '../components/expansionspanel'
import { Errorpanel } from '../components/errorpanel'

import { Modal } from '../components/modal'
import { Toolbar } from '../components/toolbar'
import { DataTable } from '../components/datatable'

import { Field } from '../components/field';
import { Input } from '../components/input';
import { Select } from '../components/select';
import { Checkbox } from '../components/checkbox';
import { RadioGroup } from '../components/radiogroup';

import { Label } from '../components/label'
import { Button } from '../components/button'
import { Link } from '../components/link'
import { Divider } from '../components/divider';
import { Image } from '../components/image';
import { Html } from '../components/html';
import { Icon } from '../components/icon';

export const registerDefault = () => {
    //Containers
    
    RegisterComponent('form', Form)
    RegisterComponent('panel', Panel)
    RegisterComponent('card', Card)
    RegisterComponent('tabs', Tabs)
    RegisterComponent('tab', Tab)
    RegisterComponent('expansionspanel', Expansionspanel)
    RegisterComponent('modal', Modal)
    RegisterComponent('toolbar', Toolbar)
    RegisterComponent('datatable', DataTable)
    //data components
    RegisterComponent('field', Field)
    RegisterComponent('input', Input)
    RegisterComponent('select', Select)
    RegisterComponent('checkbox', Checkbox)
    RegisterComponent('radiogroup', RadioGroup)

    //static
    RegisterComponent('label', Label)
    RegisterComponent('button', Button)
    RegisterComponent('link', Link)
    RegisterComponent('divider', Divider)
    RegisterComponent('image', Image)
    RegisterComponent('html', Html)
    RegisterComponent('icon', Icon)
    RegisterComponent('errorpanel', Errorpanel)
    

}



